import { useTheme as useMaterialTheme, useMediaQuery } from '@mui/material';

// value         |0px     600px    960px    1280px   1920px
// key           |xs      sm       md       lg       xl
// screen width  |--------|--------|--------|--------|-------->

export function useMediaQueries() {
  const materialTheme = useMaterialTheme();
  const mobileView = useMediaQuery(materialTheme.breakpoints.down('sm'));
  const tabletView = useMediaQuery(materialTheme.breakpoints.up('sm'));
  const mobilePadding = 'padding: 12px 1rem;';

  return {
    mobileView,
    tabletView,
    mobilePadding,
  };
}
